/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'question': {
    width: 16,
    height: 16,
    viewBox: '0 0 7 11',
    data: '<circle pid="0" cx="3.5" cy="9.3" r=".8"/><path pid="1" d="M3.5.3C1.8.3.4 1.7.4 3.4c0 .4.3.6.6.6s.6-.3.6-.6c0-1 .8-1.8 1.8-1.8s1.8.8 1.8 1.8c.1.6-.4 1.4-1.2 1.7-.7.3-1.1.9-1.1 1.6v.7c0 .4.3.6.6.6.4 0 .6-.3.6-.6v-.7c0-.2.1-.3.3-.4 1.2-.4 2.2-1.7 2.2-2.9C6.6 1.7 5.2.3 3.5.3z"/>'
  }
})
